import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CrisisBar } from "@/components/CrisisBar";
import { SiteFooter } from "@/components/landing/SiteFooter";
import { ExitIntentOffer } from "@/components/ExitIntentOffer";
import { ASSETS } from "@/data/landing";

const SITE = "https://anxiety-fix.com";

export const useSeo = ({ title, description, path, jsonLd }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const prevTitle = document.title;
    document.title = title;
    const desc = document.querySelector('meta[name="description"]');
    const prevDesc = desc?.getAttribute("content");
    desc?.setAttribute("content", description);
    const canonical = document.querySelector('link[rel="canonical"]');
    const prevHref = canonical?.getAttribute("href");
    canonical?.setAttribute("href", `${SITE}${path}`);
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      document.title = prevTitle;
      if (prevDesc) desc?.setAttribute("content", prevDesc);
      if (prevHref) canonical?.setAttribute("href", prevHref);
      script?.remove();
    };
  }, [title, description, path, jsonLd]);
};

export const BlogLayout = ({ children, backTo = "/blog", backLabel = "All articles" }) => (
  <div className="min-h-screen bg-afwn-bg text-afwn-navy">
    <header className="border-b border-afwn-navy/5 bg-white/70 backdrop-blur-xl sticky top-0 z-40">
      <CrisisBar />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="blog-logo-link" className="flex items-center gap-3">
          <img src={ASSETS.logo} alt="Anxiety Fix Wellness Network" className="h-12 w-12 object-contain rounded-full" />
          <span className="font-heading text-xl text-afwn-green leading-none">Anxiety&nbsp;Fix<span className="block text-[9px] tracking-[0.25em] uppercase text-afwn-slate font-body mt-0.5">Wellness Network</span></span>
        </Link>
        <Link to={backTo} data-testid="blog-back-link" className="inline-flex items-center gap-1.5 text-sm text-afwn-slate hover:text-afwn-green transition-colors">
          <ArrowLeft size={16} /> {backLabel}
        </Link>
      </div>
    </header>
    {children}
    <SiteFooter />
    <ExitIntentOffer />
  </div>
);

export const formatDate = (iso) => new Date(`${iso}T12:00:00Z`).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
